import { Component, Input, Output, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

import { PermissionPreviewNode } from '../../../shared/models/permissions-preview-models/permission-preview-node.model';
import { VirtualFolderPermissionsHierarchyRecord } from '../../../shared/models/permissions-preview-models/virtualFolderPerHierarchyRecord.model';

@Component({
    selector: 'app-virtual-folder-popover',
    templateUrl: './virtual-folder-popover.component.html',
    styleUrls: ['./virtual-folder-popover.component.scss'],
    standalone: false
})
export class VirtualFolderPopoverComponent implements OnInit {
    // Properties.
    @Input() permissionNode: PermissionPreviewNode = null;
    @Input() clickedPermissionName: string = null;

    @ViewChild(NgbPopover, { read: NgbPopover }) popover; //: QueryList<NgbPopover>;

    // Constructor.
    public constructor() { }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    public ngAfterViewInit(): void {
        return;
    }

    // Accessor methods.
    public get PermissionNode(): PermissionPreviewNode {
        return (this.permissionNode);
    }

    public get BuildPermissionCellNames(): string[] {
        //return ['canBuildRoles', 'canBuildWorkflows', 'canBuildForms', 'canBuildFolders', 'CanBuildFormInstances'];
        return VirtualFolderPermissionsHierarchyRecord.buildPermissionCellNames();
    }

    public get PerformPermissionCellNames(): string[] {
        //return ['canView', 'canEdit', 'canDelete', 'canGrant'];
        return VirtualFolderPermissionsHierarchyRecord.performPermissionCellNames();
    }

    public get VirtualFolderHierarchyTitle(): string {
        return (this.permissionNode.folderName);
    }

    public WorkflowHierarchyShown(): boolean {
        //let isShown: boolean = ((this.permissionNode.transientVirtualFolderHierarchyResponse != null) && this.permissionNode.transientIsShown);
        let isShown: boolean = ((this.permissionNode.transientHierarchyRecords != null) && this.permissionNode.transientIsShown);

        return (isShown);
    }

    public get HasWorkflowHierarchyRecords(): boolean {
        //return (this.permissionNode.transientVirtualFolderHierarchyResponse != null);
        return (this.permissionNode.transientHierarchyRecords != null);
    }

    public get WorkflowHierarchyRecords(): VirtualFolderPermissionsHierarchyRecord[] {
        /*
        let hierarchyRecords: VirtualFolderPermissionsHierarchyRecord[] =
            (this.permissionNode.transientVirtualFolderHierarchyResponse != null ?
                this.permissionNode.transientVirtualFolderHierarchyResponse.hierarchyRecords : []);

        return (hierarchyRecords);
        */
        return this.permissionNode.transientHierarchyRecords;
    }

    public WorkflowStateName(hierarchyRecord: VirtualFolderPermissionsHierarchyRecord): string {
        return hierarchyRecord.workflowStateName;
    }

    public CanBuild(hierarchyRecord: VirtualFolderPermissionsHierarchyRecord, permissionCellName: string): boolean {
        return hierarchyRecord.canBuild(permissionCellName);
    }

    public CanPerform(hierarchyRecord: VirtualFolderPermissionsHierarchyRecord, permissionCellName: string): boolean {
        return hierarchyRecord.canPerform(permissionCellName);
    }

    public PermissionNodeCanBuild(permissionCellName: string): boolean {
        return this.permissionNode.canBuild(permissionCellName);
    }
    public PermissionNodeCanPerform(permissionCellName: string): boolean {
        return this.permissionNode.canPerform(permissionCellName);
    }

    public get ClickedPermissionName(): string {
        return this.clickedPermissionName;
    }

    public IsClickedPermissionName(permissionName: string): boolean {
        let isClickedName: boolean = (this.clickedPermissionName == permissionName);
        return isClickedName;
    }
    // End accessor methods.
}
